import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

import { MobileContext } from 'context';
import '../popups.scss';
import './styles.scss';


export default class PopupReferrals extends React.Component {
  static contextType = MobileContext;

  get isMobile() {
    return this.context;
  }


  render() {
    if (this.props.isShown)
      return (<React.Fragment>
        <div className='Popup Overlay' />
        <div className={'Popup Generic Referrals' + (this.isMobile ? ' Mobile' : '')}>
          <div id='header'>
            <h2>Referral link</h2>
            <button id='close' onClick={this.props.closePopup}>
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
          <div>
            {this.props.content}
          </div>
          <p>
            <FontAwesomeIcon icon={faCircleInfo} />
            Share this link with your frieds to get rewards.
          </p>
        </div>
      </React.Fragment>);
    else
      return null;
  }
}
